import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './paymentTool.json';

const queryPaymentToolSetting = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['paymentToolController/queryPaymentToolSetting'].success.default)));
};

const queryTransactionNotifySetting = (req, res, ctx) => {
  return res(
    ctx.json(mockResponse(apiResponses['paymentToolController/queryTransactionNotifySetting'].success.default))
  );
};

const queryWarningAmountSetting = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['paymentToolController/queryWarningAmountSetting'].success.default)));
};

const queryPaymentInfo = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['paymentToolController/queryPaymentInfo'].success.default)));
};

const settingTransactionNotify = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['paymentToolController/settingTransactionNotify'].success.default)));
};

export const handlers = [
  rest.post(
    getApiEndpoint('paymentToolController/queryPaymentToolSetting'),
    withScenario(withAuthCheck(queryPaymentToolSetting))
  ),
  rest.post(
    getApiEndpoint('paymentToolController/queryTransactionNotifySetting'),
    withScenario(withAuthCheck(queryTransactionNotifySetting))
  ),
  rest.post(
    getApiEndpoint('paymentToolController/queryWarningAmountSetting'),
    withScenario(withAuthCheck(queryWarningAmountSetting))
  ),
  rest.post(getApiEndpoint('paymentToolController/queryPaymentInfo'), withScenario(withAuthCheck(queryPaymentInfo))),
  rest.post(
    getApiEndpoint('paymentToolController/settingTransactionNotify'),
    withScenario(withAuthCheck(settingTransactionNotify))
  ),
];
